import {
  Typography,
  Select,
  MenuItem,
  TextField,
  Box,
} from "@material-ui/core";
import { useState, useMemo, useEffect } from "react";
import { LoggerCondition } from "../../../../api/automation";
import { SubConditionInput, Spacer, parseNumber } from "./Helpers";

export const LoggerConditionInput: SubConditionInput<LoggerCondition> = ({
  info: { loggers },
  value,
  onChange,
}) => {
  const [metric, setMetric] = useState<LoggerCondition["metric"] | undefined>(
    value.metric ?? undefined
  );
  const [threshold, setThreshold] = useState<number | undefined>(
    value.threshold ?? undefined
  );
  const [comparison, setComparison] = useState<
    LoggerCondition["comparison"] | undefined
  >(value.comparison ?? undefined);
  const [logger_id, setLoggerId] = useState<
    LoggerCondition["logger_id"] | undefined
  >(value.logger_id ?? undefined);
  const comparisonOptions = ["gt", "lt"];

  const result = useMemo<LoggerCondition | null>(() => {
    if (
      metric === undefined ||
      threshold === undefined ||
      comparison === undefined ||
      logger_id === undefined
    ) {
      return null;
    }
    return {
      type: "logger",
      logger_id,
      metric,
      threshold,
      comparison,
    };
  }, [metric, threshold, comparison, logger_id]);

  useEffect(() => {
    onChange(result);
  }, [result]);

  const options: LoggerCondition["metric"][] = ["battery", "solar_panel"];

  return (
    <Box>
      <Typography>
        When logger
        <Spacer>
          <Select
            value={logger_id ?? ""}
            onChange={(e) =>
              setLoggerId(e.target.value as LoggerCondition["logger_id"])
            }
          >
            {loggers?.map((l) => (
              <MenuItem value={l.id} key={l.id}>
                #{l.logger_id}
              </MenuItem>
            ))}
          </Select>
        </Spacer>
        <Spacer>
          <Select
            value={metric ?? ""}
            onChange={(e) =>
              setMetric(e.target.value as LoggerCondition["metric"])
            }
          >
            {options.map((m) => (
              <MenuItem value={m} key={m}>
                {m === "battery" ? "Battery Voltage" : "Solar Panel Voltage"}
              </MenuItem>
            ))}
          </Select>
        </Spacer>
        is
        <Spacer>
          <Select
            label="comparison"
            value={comparison ?? ""}
            onChange={(e) => {
              setComparison(e.target.value as LoggerCondition["comparison"]);
            }}
          >
            {comparisonOptions.map((c) => (
              <MenuItem value={c} key={c}>
                {c === "gt" ? "greater" : "less"}
              </MenuItem>
            ))}
          </Select>
        </Spacer>
        than
        <Spacer>
          <TextField
            value={threshold}
            type="number"
            onChange={(e) => setThreshold(parseNumber(e.target.value))}
          />
        </Spacer>
      </Typography>
    </Box>
  );
};
